module.exports = __webpack_public_path__ + "img/money_bag_bill_coins_color.1901b8c3.png";